import React from 'react';
import { Download } from 'lucide-react';
import ProgressBar from '../common/ProgressBar';
import Button from '../common/Button';
import { useConversionTask } from '../../hooks/useConversionTask';
import { getDownloadUrl } from '../../services/conversionApi';
import './TaskProgressPanel.css';

interface TaskProgressPanelProps {
    taskId: string;
    onReset?: () => void;
    onComplete?: () => void;
}

const TaskProgressPanel: React.FC<TaskProgressPanelProps> = ({ taskId, onReset, onComplete }) => {
    const progressSource = useConversionTask(taskId);
    const prevStatus = React.useRef(progressSource.status);

    React.useEffect(() => {
        if (
            (progressSource.status === 'completed' || progressSource.status === 'failed') &&
            prevStatus.current !== 'completed' && prevStatus.current !== 'failed'
        ) {
            if (onComplete) onComplete();
        }
        prevStatus.current = progressSource.status;
    }, [progressSource.status, onComplete]);

    const handleDownload = () => {
        const downloadUrl = getDownloadUrl(taskId);
        window.open(downloadUrl, '_blank');
    };

    return (
        <div className="task-progress-panel">
            <ProgressBar status={progressSource.status as any} stage={progressSource.stage} progress={progressSource.progress} />

            {progressSource.status === 'completed' && (
                <div className="task-actions success-actions">
                    <p className="success-message">🎉 转换成功！</p>
                    <div className="action-buttons">
                        <Button variant="primary" onClick={handleDownload} icon={<Download />}>
                            下载结果文件
                        </Button>
                        {onReset && (
                            <Button variant="outline" onClick={onReset}>
                                继续转换
                            </Button>
                        )}
                    </div>
                </div>
            )}

            {(progressSource.status === 'failed' || progressSource.status === 'disconnected') && (
                <div className="task-actions error-actions">
                    <p className="error-message">❌ 转换失败：{progressSource.error || '未知错误'}</p>
                    {onReset && (
                        <div className="action-buttons">
                            <Button variant="primary" onClick={onReset}>
                                重新尝试
                            </Button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default TaskProgressPanel;
